import React from 'react';
import styled from 'styled-components';
import * as utils from 'utils';

export const icpLicenseMessage = '沪ICP备16021024号';

// Sits in the normal flow as the last child of the app's 100vh flex column, so the routed
// content above it shrinks to fit. It used to be `position: fixed; bottom: 0`, which floated
// it over the bottom of the page and hid whatever was underneath - the horizontal scrollbar
// of FjSortTable and the side nav's version link.
const StyledFooter = styled.footer`
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1rem;
  background-color: #f2f2f2;
  width: 100%;
  font-size: 14px;
`;

const FooterLeft = styled.div`
  order: 1;
`;

const FooterMiddle = styled.div`
  order: 2;
`;

const FooterRight = styled.div`
  order: 3;
`;

export const Footer = (testHook = false): React.JSX.Element | string => {
  const chinaFlag = utils.chinaFlag();
  if (chinaFlag || testHook === true) {
    return (
      <StyledFooter>
        <FooterLeft />
        <FooterMiddle>{icpLicenseMessage}</FooterMiddle>
        <FooterRight />
      </StyledFooter>
    );
  }
  return '';
};
